<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14.231" height="10.435" viewBox="0 0 14.231 10.435">
    <path id="Path_882" d="M102.171,157.14a2.259,2.259,0,0,1-1.607-.669l-2.857-2.852a1.435,1.435,0,0,1,0-2.029h0a1.435,1.435,0,0,1,2.029,0l2.435,2.434,6.9-6.9a1.435,1.435,0,0,1,2.029,0h0a1.435,1.435,0,0,1,0,2.029h0l-7.321,7.321A2.257,2.257,0,0,1,102.171,157.14Z" transform="translate(-97.286 -146.705)" :fill="fill"/>
  </svg>
</template>
<script setup lang="ts">
  defineProps({
    fill: {
      type: String,
      default: '#000ec6',
    },
  });
</script>